/* Small storefront behaviours that need no component of their own. */
(function () {
  'use strict';

  // Header search pill opens the search modal.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ss-open-search]');
    if (!trigger) return;
    var summary = document.querySelector('.header__search details > summary');
    if (summary) {
      event.preventDefault();
      summary.click();
      var input = document.querySelector('.header__search input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }
  });

  // Mark the <html> while the cart drawer is open so floating widgets can hide (see ss-theme.css).
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var sync = function () {
      document.documentElement.classList.toggle('ss-cart-drawer-open', drawer.classList.contains('active'));
    };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  // External links open in a new tab.
  function externalLinks() {
    Array.prototype.forEach.call(document.links, function (link) {
      if (link.hostname && link.hostname !== window.location.hostname && /^https?:$/.test(link.protocol)) {
        link.target = '_blank';
        link.rel = 'noreferrer noopener';
      }
    });
  }

  // Sticky add-to-cart bar (product_sticky-atc block) forwards to the main product form button.
  function stickyAtc() {
    var bar = document.querySelector('[data-ss-sticky-atc]');
    if (!bar) return;
    var atc = document.getElementById('ProductSubmitButton-' + bar.dataset.section);
    var button = bar.querySelector('[data-ss-sticky-atc-button]');
    if (!atc || !button) return;
    button.addEventListener('click', function () {
      atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      atc.click();
    });
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }).observe(atc);
  }

  // Pagination dots inside plain <slider-component> galleries (Dawn only wires them for slideshows).
  function galleryDots() {
    document.addEventListener('click', function (event) {
      var dot = event.target.closest('.slider-counter__link');
      if (!dot || dot.closest('slideshow-component')) return;
      var slider = dot.closest('slider-component');
      var track = slider && slider.querySelector('.slider');
      if (!track) return;
      event.preventDefault();
      var dots = Array.prototype.slice.call(slider.querySelectorAll('.slider-counter__link'));
      var index = dots.indexOf(dot);
      var slide = track.querySelectorAll('.slider__slide')[index];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    });
    document.addEventListener('slideChanged', function (event) {
      var slider = event.target;
      if (!slider.matches || !slider.matches('slider-component') || slider.matches('slideshow-component')) return;
      var page = event.detail && event.detail.currentPage;
      if (!page) return;
      slider.querySelectorAll('.slider-counter__link').forEach(function (dot, i) {
        dot.classList.toggle('slider-counter__link--active', i === page - 1);
      });
    }, true);
  }

  function init() {
    galleryDots();
    watchDrawer();
    externalLinks();
    stickyAtc();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
